import { createContext, FC, ReactNode, useContext, useState } from 'react'

const MenuContext = createContext({
  isOpen: false,
  toggleMenu: () => {},
  closeMenu: () => {},
})

type Props = {
  children: ReactNode
}

export const MenuContextProvider: FC<Props> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <MenuContext.Provider
      value={{
        isOpen,
        toggleMenu: () => setIsOpen(v => !v),
        closeMenu: () => setIsOpen(false),
      }}
    >
      {children}
    </MenuContext.Provider>
  )
}

export const useMenuContext = () => useContext(MenuContext)
